module.exports = __webpack_public_path__ + "static/Add-YouTube-Video-1-e1403554495858-36250c3f4f51e9d0fc3df85e9062e33c.jpg";